import React from 'react';
import styles from '../../../styles/components/forms/BookingForm.module.css';

const FormHeader = ({ isDarkMode }) => {
    return (
        <div className={styles['form-header-container']}>
            <p className={`${styles['form-header']} ${isDarkMode ? styles['form-header-dark'] : ''}`} id="booking-form-title">
                Get An Instant Quote
            </p>
        </div>
    );
};

export default FormHeader;
